export default {"src":"/_next/static/media/reading-book.colour.b7b139f0.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};